import React, { useState, useEffect } from "react";
import _ from "lodash";
import Booking from "../components/Steps/Booking";
import { Spin, Button } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import History from "../components/Steps/History";
import { LeftOutlined } from "@ant-design/icons";
import Map from "../components/Steps/Map";

const Home = ({ token }) => {
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState("booking");
  const [dataServices, setDataServices] = useState(null);
  const [isPlaceHistory, setIsPlaceHistory] = useState(false);
  const [dataPlace, setDataPlace] = useState({
    from: {
      placeId: "",
      description: "",
      placeName: "",
      lat: "",
      lng: "",
      regionName: "",
    },
    to: {
      placeId: "",
      description: "",
      placeName: "",
      lat: "",
      lng: "",
      regionName: "",
    },
  });
  const [dataInputPlace, setDataInputPlace] = useState({
    from: "",
    to: "",
  });
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
    if (!step && token) {
      setStep("booking");
    }
  }, [location, history, token]);

  return (
    <Spin tip="Tải dữ liệu" size="large" spinning={loading}>
      <div
        className="bg-white min-h-screen"
      >
        <div
          className="w-full h-[300px] absolute"
          style={{
            backgroundImage: `url(/images/bg-form.png)`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center center",
          }}
        ></div>
        {step !== "map" && (
          <div className="flex w-full z-10 justify-between items-center">
            {step === "booking" ? (
              <div className="w-[67px] h-8"></div>
            ) : (
              <div className="w-[67px] ml-4">
                <Button
                  className="text-[14px]"
                  icon={<LeftOutlined color="#1677ff" />}
                  onClick={() => {
                    setStep("booking");
                  }}
                />
              </div>
            )}
            <div className="text-center">
              <a href="/taxi">
                <img
                  src={"/images/logo-taxi.jpg"}
                  alt=""
                  className="w-[60px] rounded-full"
                />
              </a>
            </div>
            {step === "booking" ? (
              <div className="p-5 cursor-pointer inline-block z-10">
                <img
                  onClick={() => {
                    setStep("history");
                  }}
                  className="w-[32px] p-1 h-[32px] bg-white rounded-full"
                  src={"/images/history.svg"}
                  alt=""
                />
              </div>
            ) : (
              <div className="w-[67px] h-8"></div>
            )}
          </div>
        )}
        {step === "booking" && (
          <Booking
            setLoading={setLoading}
            loading={loading}
            setDataServices={setDataServices}
            setStep={setStep}
            setDataPlace={setDataPlace}
            dataPlace={dataPlace}
            setDataInputPlace={setDataInputPlace}
            dataInputPlace={dataInputPlace}
            isPlaceHistory={isPlaceHistory}
            setIsPlaceHistory={setIsPlaceHistory}
          />
        )}
        {step === "map" && (
          <Map
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
            dataServices={dataServices}
            setDataServices={setDataServices}
            setDataPlace={setDataPlace}
            dataPlace={dataPlace}
            setDataInputPlace={setDataInputPlace}
            dataInputPlace={dataInputPlace}
          />
        )}
        {step === "history" && (
          <History
            setStep={setStep}
            setLoading={setLoading}
            loading={loading}
            dataServices={dataServices}
            setDataPlace={setDataPlace}
            dataPlace={dataPlace}
            setDataInputPlace={setDataInputPlace}
            dataInputPlace={dataInputPlace}
            setIsPlaceHistory={setIsPlaceHistory}
          />
        )}
      </div>
    </Spin>
  );
};

export default Home;
